import { ProjectFragment } from '@sc/graphql';

/**
 * The project's public URL: a custom domain when one is attached (stored without
 * a protocol), otherwise the hosted Stark Chat URL. Shared by the settings Domain
 * tab and the "published" success modal so they always point to the same place.
 */
export const getProjectUrl = (
  project: Pick<ProjectFragment, 'domainPrefix' | 'domains'>,
  chatsUrl: string
): string =>
  project.domains[0]?.url
    ? `https://${project.domains[0].url}`
    : `${chatsUrl}/chat/${project.domainPrefix}`;
